import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { reduxForm, getFormValues } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import UserHeader from '../../organisms/UserHeader';
import m from 'moment';
import * as common from '../../common';
import axios from 'axios';
import conf from '../../../config/config.js';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 4px 16px 4px',
    backgroundColor: '#fafafa',
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',   
  },
  buttonS: {
    width: "60%",
    height: "40px",
    margin: "0 10px 0 20px"
  },
  typography:{
    margin: '0 25px 0 25px'
  },
  typography2:{
    margin: '30px 10px 0 10px'
  },
  typography3:{
    margin: '10px 10px -10px 16px'
  },
  typographyImg:{
    margin: '10px 10px 0 16px'
  },
  typographyDescription:{
    lineHeight: "1.3em"
  },
  textFieldL: {
    margin: '10px 10px 5px 10px',
  },
  textFieldS: {
    margin: '10px 10px 5px 10px',
    width: '55%'
  },
  textFieldS3: {
    margin: '10px 10px 5px 10px',
    width: '200px'
  },
  textFieldDate: {
    margin: '10px 10px 5px 10px',
    width: '40%',
    minWidth: '240px',
  },
  fields4: {
    margin: '0px 10px 15px 10px',
    width: '250px',
  },
  button: {
    width: '100%',
  },
  formControl: {
    margin: '10px 20px 10px 20px',
  },
  formLabel: {
    color: "#212121",
    margin: "0 0 5px -5px"
  },
  dateMark: {
    marginTop: "22px",
    fontSize: "1.2em"
  },
  cardimage: {
    width: '100%',
    fontSize: "0.9em",
  },
  media: {
    width: '100%',
  },
  cardContent: {
    textAlign: 'left',
    padding: "2px 8px 0px 8px",
    "&:last-child": {
      paddingBottom: "10px"
    }
  },
  circle: {
    textAlign: 'center'
  },
  container1: {
    fontSize: "0.5em",
    margin: "40px 0 0 1px",
    width: '10px',
  },
  label2: {
    padding: '0 0 0 10px',
    width: '100%',
  },
  typographyWarn: {
    color: "#ffffff",
    backgroundColor: "#e60033",
    borderRadius: '99px',
    border: "solid 1px #e60033",
    margin: '10px 10px 0 10px',
    padding: '7px 4px 4px 8px',
    fontSize: "0.8em",
  }, 
  formLabel2: {
    color: "#212121",
    width: '30px',
  },   
  containerGridItem: {
    margin: "0 0 0 0",
    marginRight: "0",
    padding: '0',
  },
  fields3: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 4px 16px 4px',
    margin: '0',
  },  
});

var attachmentFiles = [];

class WorkConsiderSeparation extends React.Component {

  // 添付資料ダウンロード
  onDownloadFile = async(e) => {
    e.preventDefault();
    const { auth, applyDetail, doOpenDialog } = this.props;
    console.log('start onDownloadFile');
    
    let TargetFileName = "資料_" + e.currentTarget.text;
    let ParentId = '';
    let FileName = '';
    let FilePass = '';
    let FileType = '2';

    applyDetail.data.Attachment.map(function(item) {
      if (TargetFileName === item.Name) {
        FileName = item.Name;
        FilePass = item.Body;
      }
      return null;
    });
    
    let browser = common.browser();
    let childWindow;
    let childWindowName = FileName + ("00000" + Math.floor(Math.random() * 100000)).slice(-5);
    console.log('childWindowName:' + childWindowName);
    // Safariポップアップ抑止対策
    if (browser === 'IOS_SAFARI' || browser === 'MAC_SAFARI') {
      childWindow = window.open('', childWindowName);
    }

    try {
      const ret = await axios.post(conf.API_URL + "GetAttachedFile/getContentDocument",
                        { ParentId, FileName, FilePass, FileType }, {
                        headers: {
                          Authorization: auth.loginInfo.idToken,
                        }
      });
      var pos = FileName.indexOf(".");
      var filetype = "";
      var apptype = ""; 
      filetype = FileName.slice(pos);
      console.log("拡張子= " + filetype);
      apptype = "application/pdf";
      if(filetype === ".png"){
        apptype = 'image/png';
       }
       else if(filetype === ".gif"){
        apptype = 'image/gif';   
       }
       else if(filetype === ".jpg" || filetype === ".jpeg"){
        apptype = 'image/jpeg';
       }
      console.log("apptype= " + apptype); 
      const blob = common.base64toBlob(ret.data.body.data.attachmentFileBody, apptype);
      window.URL = window.URL || window.webkitURL;
      const url = window.URL.createObjectURL(blob);
      childWindow = window.open(url, childWindowName);
      setTimeout(()=>{
        childWindow.document.title = FileName.replace("資料_", "");
      }, 100);
    }catch(e){
      console.log("error 添付資料ダウンロード失敗 " + e.message);
      if (childWindow) childWindow.close();
      const dialog = {
        type: 'ok', // 閉じるのみ表示
        title: '',
        message: 'workConsideration.dialog.error.DLfile',
      };
      doOpenDialog(dialog);
    }
    console.log('end onDownloadFile');
  }

  // お見積金額確認
  onClickEstimateConfirm = () => {
    this.props.history.push('/workEstimateConfirm');
  };

  // ご請求金額確認
  onClickBillConfirm = () => {
    this.props.history.push('/workBillConfirm');
  };

  // 承諾ボタンクリック
  onClickConsent = () => {
    const { doOpenDialog } = this.props;
    const dialog = {
      type: 'okcancel', // 「確認」と「キャンセル」を表示
      title: '',
      message: 'workConsideration.dialog.inquiry',
      action: this.doAction
    };
    doOpenDialog(dialog);
  }

  // 承諾処理実行
  doAction = async() => {

    const { doApplyConsentOperation, doOpenDialog } = this.props;
    try {
      const result = await doApplyConsentOperation();
      console.log(result);
      if (result === '00000') {
        // 正常
        const dialog = {
          type: 'ok', // '閉じる'のみ表示
          title: '',
          message: 'workConsiderationSeparation.dialog.finish',
          action: this.onClickBack
        };
        doOpenDialog(dialog);
      }
      else if (result === '20800') {
        // 取付申込承諾失敗
        const dialog = {
          type: 'close', // '閉じる'のみ表示
          title: '',
          message: 'workConsiderationSeparation.dialog.error.failure2',
          action: this.onClickBack
        };
        doOpenDialog(dialog);
      }
      else {
        // その他エラー
        const dialog = {
          type: 'error', // '閉じる'のみ表示
          title: 'system.message.error.title',
          message: 'system.message.error.context',
        };
        doOpenDialog(dialog);
      }
    }
    catch (err) {
      console.log(`エラー: ${err}`);
      // その他エラー
      const dialog = {
        type: 'error', // '閉じる'のみ表示
        title: 'system.message.error.title',
        message: 'system.message.error.title',
      };
      doOpenDialog(dialog);
    }
  };

  // 問合せ/写真追加
  onClickInquiry = () => {
    this.props.history.push('/workInquiry');
  };

  // 戻る
  onClickBack = () => {
    this.props.history.push('/workMenu');
  };

  render() {
    const { classes, applyDetail } = this.props;

    let applyData = [];
    let guidMessageID = '';
    let isEstimateBtnDisable = true;
    let isBillBtnDisable = true;
    let isConsentBtnDisable = true;
    
    if (applyDetail) {
      if (applyDetail.errorCode === '00000') {
        // 申込詳細の取得
        if (applyDetail.data) {
          applyData = applyDetail.data;
        }
        // 添付資料の取得
        if (applyDetail.data.Attachment) {
          attachmentFiles = applyDetail.data.Attachment;
        }
      }
      else if (applyDetail.errorCode === '20700' || applyDetail.errorCode === '20701') {
        // 詳細取得エラーだった場合(申込メニュー画面へ遷移)
        const { doOpenDialog } = this.props;
        const dialog = {
          type: 'ok', // '閉じる'のみ表示
          title: '',
          message: 'workConsiderationSeparation.dialog.error.failure',
          action: this.onClickBack
        };
        doOpenDialog(dialog);
      } else {
        // その他エラー(ログイン画面へ遷移)
        const { doOpenDialog } = this.props;
        const dialog = {
          type: 'error', // '閉じる'のみ表示
          title: 'system.message.error.title',
          message: 'system.message.error.context',
        };
        doOpenDialog(dialog);
      }
    }

    if (applyDetail) {
      // メッセージ切り替え
      if (applyData.Status__c === "撤去可否登録～撤去工事検査" && applyData.RemoveProperty__c === "否") {
        // 撤去確認待
        guidMessageID = 'workConsideration.message.removalConfirm';
      } else if ( !applyData.FreeOfChargeFlag__c ) {
          if (applyData.Status__c === "承諾入力～取付工事検査" && applyData.AttachApprovalInput__c === "未") {
            // 有償 見積金額確認待
            guidMessageID = 'workConsideration.message.estimateConfirm';
          } else if (applyData.Status__c === "精算" && applyData.AttachWork.PaymentAcceptance__c === "未") {
            // 有償 請求金額確認待
            guidMessageID = 'workConsideration.message.billConfirm';
          }
      } else {
        if (applyData.Status__c === "承諾入力～取付工事検査" && applyData.AttachApprovalInput__c === "未") {
          // 無償 承諾待
          guidMessageID = 'workConsideration.message.consent';
        }
      }

      // ボタン活性非活性切り替え
      if (!applyData.UnnecessaryEstimate__c
          && (applyData.Status__c === "承諾入力～取付工事検査"
            || applyData.Status__c === "精算"
            || applyData.Status__c === "撤去可否登録～撤去工事検査"
            || applyData.Status__c === "完了")) {
        isEstimateBtnDisable = false;
      }
      if ((!applyData.BillingUnnesessary__c || applyData.CancelChargeRequest__c)
          && (applyData.Status__c === "精算"
            || applyData.Status__c === "撤去可否登録～撤去工事検査"
            || applyData.Status__c === "完了")) {
        isBillBtnDisable = false;
      }
      if (applyData.Status__c === "承諾入力～取付工事検査" && applyData.AttachApprovalInput__c === "未") {
        isConsentBtnDisable = false;
      }
    }

    return (
      <div className={classes.root}>
      <form noValidate autoComplete="off" className={classes.root}>
      <UserHeader />

        <Typography variant="h5" className={classes.typography2}>件名：{applyData.OrderName__c}</Typography>

{/* 現場所在地(住所) */}
      <Grid container>
        <TextField
          id="WorkSiteAddress__c"
          name="WorkSiteAddress__c"
          label={<FormattedMessage id='workConsiderationSeparation.in.workaddress'/>}
          className={classes.textFieldL}
          value={applyData.WorkSiteAddress__c ? applyData.WorkSiteAddress__c : ''}
          margin="normal"
          style={{ width: "100%" }}
          InputProps = {{
            readOnly: true
          }}
          variant="outlined"
        />
      </Grid>

{/* 現場所在地(電柱番号) */}
        <TextField
          id="WorkSitePoleNo__c"
          name="WorkSitePoleNo__c"
          label={<FormattedMessage id='workConsiderationSeparation.in.poleNumber'/>}
          className={classes.textFieldS}
          style={{ width: "200px" }}
          value={applyData.WorkSitePoleNo__c ? applyData.WorkSitePoleNo__c: ''}
          margin="normal"
          InputProps = {{
            readOnly: true
          }}
          variant="outlined"
        />

{/* 作業期間 */}
        <Grid container>
          <TextField
            id="StartRequireAttachTerm__c"
            className={classes.textFieldDate}
            label="作業日（自）"
            value={applyData.StartRequireAttachTerm__c ? m(applyData.StartRequireAttachTerm__c).format("YYYY/MM/DD") : ""}
            margin="normal"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Typography className={classes.dateMark}>～</Typography>
          <TextField
            id="EndRequireAttachTerm__c"
            className={classes.textFieldDate}
            label="作業日（至）"
            value={applyData.EndRequireAttachTerm__c ? m(applyData.EndRequireAttachTerm__c).format("YYYY/MM/DD") : ""}
            margin="normal"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

{/* 添付資料 */}
        <Typography variant="subtitle1" className={classes.typography3}>添付資料</Typography>
        
        <p style={{fontSize: 5, height: 2}}></p>
          <Typography variant="body2" className={classes.typographyValue} style={{paddingLeft:"20px"}}>
          {attachmentFiles.map((item) => (
            <>
            ・<u style={{color:'#0000ff', cursor:'hand'}}>
                  <a target="_blank" rel="noopener noreferrer" href="true" onClick={this.onDownloadFile}>
                    {item.Name.replace("資料_", "")}
                  </a>
              </u>
              <br></br>
            </>
          ))}
          </Typography>
        <p></p>

{/* ご連絡事項 */}
        <TextField
          id="Message__c"
          name="Message__c"
          label={<FormattedMessage id='workConsiderationSeparation.in.memo'/>}
          className={classes.textFieldL}
          value={applyData.Message__c ? applyData.Message__c : ''}
          margin="normal"
          variant="outlined"
          InputProps = {{
            readOnly: true
          }}
          multiline={true}
          rows={3}
        />

        <div style={{margin: "20px 0 15px 0"}}>
        {guidMessageID &&
          <Typography align="center"><font size="3"><FormattedMessage id={guidMessageID}/></font></Typography>
        }
        </div>        <p></p>
        <Grid container>
          <Grid item xs={2}></Grid>
          <Grid item xs={8}>
            <Grid container spacing={8}>
              {!applyData.FreeOfChargeFlag__c &&
                <React.Fragment>
                  <Grid item xs={12}>
                    {/* お見積金額確認ボタン */}
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      size="large"
                      onClick={this.onClickEstimateConfirm}
                      disabled={isEstimateBtnDisable}
                    >
                    <span><FormattedMessage id={'workConsiderationSeparation.btn.estimateConfirm'}/></span>
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    {/* ご請求金額確認ボタン */}
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      size="large"
                      onClick={this.onClickBillConfirm}
                      disabled={ isBillBtnDisable }
                    >
                    <span><FormattedMessage id={'workConsiderationSeparation.btn.billConfirm'}/></span>
                    </Button>
                  </Grid>
                </React.Fragment>
              }
              {applyData.FreeOfChargeFlag__c &&
                <Grid item xs={12}>
                  {/* 承諾ボタン */}
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    size="large"
                    onClick={this.onClickConsent}
                    disabled={isConsentBtnDisable}
                  >
                  <span><FormattedMessage id={'workConsiderationSeparation.btn.consent'}/></span>
                  </Button>
                </Grid>
              }
              <Grid item xs={12}>
                {/* 問合せ・写真追加ボタン */}
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  size="large"
                  onClick={this.onClickInquiry}
                >
                  <span><FormattedMessage id={'workConsiderationSeparation.btn.inqualy.add'}/></span>
                </Button>
              </Grid>
              <Grid item xs={12}>
                {/* 戻るボタン */}
                <Button
                  variant="outlined"
                  color="primary"
                  className={classes.button}
                  size="large"
                  onClick={this.onClickBack}
                >
                  <span><FormattedMessage id={'common.btn.back'}/></span>
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={2}></Grid>
        </Grid>
      </form>
      </div>
    );
  }
}

const FORM_NAME = "WorkConsiderSeparation";

WorkConsiderSeparation.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

WorkConsiderSeparation = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
})(connect(state => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(WorkConsiderSeparation));


export default withStyles(styles)(
  connect( )(injectIntl(WorkConsiderSeparation))
);
